import { StyledRadio, Label } from "./styles";
import PropTypes from "prop-types";
import cx from "classnames";
import styled from "styled-components";

import {
  CheckboxFilledControl,
  checkboxStyles,
} from "@literati/public-ui-shared-react";

const Checkmark = checkboxStyles.Svg;
const Indicator = styled(CheckboxFilledControl)`
  background-color: ${({ $checked }) => ($checked ? "#546ac9" : "#fff")};
  margin-right: 4px;
  min-height: 1.2rem;
  min-width: 1.2rem;
  height: 1.2rem;
  width: 1.2rem;
  border-color: ${({ $checked }) => ($checked ? "#546ac9" : "#bababa")};
  border-width: 1px;
`;

const Radio = ({
  analyticsLabel,
  wrapped,
  className,
  label,
  disabled,
  withCheckmark,
  highlightBackground,
  selectedValue,
  value,
  ...props
}) => {
  const checked = selectedValue === value;
  return (
    <StyledRadio
      className={cx("radio-btn text-default", className, { wrapped })}
      data-analytics={analyticsLabel}
      highlightBackground={highlightBackground}
      selectedValue={selectedValue}
      value={value}
    >
      <Label>
        <input value={value} type="radio" {...props} disabled={disabled} />
        <Indicator $checked={checked}>
          <Checkmark
            $checked={checked}
            fill="none"
            height="9"
            viewBox="0 0 12 9"
            width="12"
            xmlns="http://www.w3.org/2000/svg"
            $scale={0.85}
          >
            <path
              d="M11 1L4.125 7.875L1 4.75"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </Checkmark>
        </Indicator>
        {label}
      </Label>
    </StyledRadio>
  );
};

Radio.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  label: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  wrapped: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  analyticsLabel: PropTypes.string,
  disabled: PropTypes.bool,
  withCheckmark: PropTypes.bool,
};

Radio.defaultProps = {
  withCheckmark: false,
};

export default Radio;
